import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../components/Navbar';
import whobanner from "../img/ourcorexperts.jpg";
import Footer from '../components/Footer';

const OurCoreXperts = ({ name }) => {
  const [activeTab, setActiveTab] = useState('Technology & Development');
  const [showScroll, setShowScroll] = useState(false);
  const [scrollProgress, setScrollProgress] = useState(0); // 0–1 fraction

  // Scroll to top smoothly (for button)
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  // Handle scroll: show button + update progress circle
  useEffect(() => {
    const handleScroll = () => {
      const totalHeight = document.documentElement.scrollHeight - window.innerHeight;
      const progress = totalHeight > 0 ? window.scrollY / totalHeight : 0; // 0–1
      setScrollProgress(progress);
      setShowScroll(window.scrollY > 300);
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll(); // Initial check

    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Scroll to top on component mount and when name prop changes
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [name]);

  // Additional scroll-to-top that runs immediately on mount
  useEffect(() => {
    // Force scroll to top immediately
    window.scrollTo(0, 0);
    // Also set scroll position in case browser restores scroll position
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 0);
  }, []);

  // WOW.js initialization (no scroll here, so tabs won't jump to top)
  useEffect(() => {
    if (window.WOW) {
      const wow = new window.WOW({
        live: false,
        boxClass: 'wow',
        animateClass: 'animated',
        offset: 0,
        mobile: true,
      });
      wow.init();
    }
  }, [activeTab]);

  const teamData = {
    'Technology & Development': [
      { img: '/img/divya1.jpeg', name: 'B. Divya Sri ', role: 'Sr. React Developer' },
      { img: '/img/amit profile photo.png', name: 'S. Amit Kumar', role: 'Sr. UI/UX Designer' },
      { img: '/img/kishoreMediboina pic.jpg', name: 'M. Kishore', role: 'Sr. Software Engineer' },
      
      { img: '/img/img4.jpg', name: 'V. Jagadeesh', role: 'Jr. Software Engineer' },
     
      { img: '/img/sneha.jpg', name: 'D. Sneha', role: 'Jr. Software Engineer' },
      { img: '/img/saradhi.jpg', name: 'V. Sai Vijaya Saradhi', role: 'Jr. Software Engineer' },
      { img: '/img/G Ruthveek.png', name: 'G. Ruthveek', role: 'Jr. Software Engineer' },
      { img: '/img/Sheetalk.jpeg', name: 'K. Sheetal', role: 'Jr. Software Engineer' },
      { img: '/img/baji.jpg', name: 'K. Bajibabu', role: 'Jr. Software Engineer' },
      { img: '/img/K Sathwika.jpg', name: 'K. Sathwika', role: 'Jr. Software Engineer' },
      { img: '/img/prakashm.jpg', name: 'M. Naga Prakash', role: 'Jr. Software Engineer' },
      { img: '/img/Yamanapalli Mohana Rao.jpg', name: 'Y. Mohana Rao', role: 'Jr. Software Engineer' },
      { img: '/img/indranadh.jpg', name: 'M. Indranadh', role: 'Jr. Software Engineer' },
          { img: '/img/preetham.jpg', name: 'G. Preetham Kumar', role: 'Jr. Software Engineer' },

      { img: '/img/ashok.jpeg', name: 'B. Ananth Krushna Rajesh', role: 'Jr. Software Engineer' },
      { img: '/img/img13.png', name: 'T. Rahul', role: 'Jr. Software Engineer' },
      
      { img: '/img/img15.jpg', name: 'M. Bhaskar', role: 'Jr. Software Engineer' },
      { img: '/img/hari.jpg', name: 'M. Hari Krishna ', role: 'Jr. Software Engineer' },
      { img: '/img/uma.jpg', name: 'K. Uma Maheshwari ', role: 'Jr. Software Engineer' },
      

      { img: '/img/saikrishna.jpg', name: 'B. Sai Krishna', role: 'Jr. Software Engineer' },
      { img: '/img/poojita.jpg', name: 'S. Poojitha', role: 'Jr. Software Engineer' },
      
      { img: '/img/harshni.jpg', name: 'M. Harshini', role: 'Jr. Software Engineer' },
      { img: '/img/photo.png', name: 'K. Sai Krishna', role: 'Jr. Software Engineer' },
      { img: '/img/ppraven.jpg', name: 'P. Praveen', role: 'Jr. Software Engineer' },
      { img: '/img/srinidhi.jpg', name: 'A. Srinidhi', role: 'Jr. Software Engineer' },
      { img: '/img/arun.jpg', name: 'A. Arun', role: 'Jr. Software Engineer' },
     
      { img: '/img/nikhila.jpg', name: 'M. Nikhila', role: 'Jr. QA Test Engineer' },
      { img: '/img/dharani.jpg', name: 'M. Dharani', role: 'Jr. QA Test Engineer ' },
    { img: '/img/maheshwarii.jpg', name: 'N. Maheshwari', role: 'Jr. QA Test Engineer ' },
      { img: '/img/img16.jpg', name: 'D. Sampath', role: 'Jr. QA Test Engineer' },
      { img: '/img/hema.jpg', name: 'A. Hema', role: 'Jr. QA Test Engineer' },
      { img: '/img/Basheera Shaik.jpg', name: 'Basheera Shaik', role: 'Jr. QA Test Engineer' },
      { img: '/img/sai sushma.jpg', name: 'P. Sai Sushma', role: 'UI/UX Designer' },
    ],
    'Operations & Managment': [
      { img: '/img/shivani.jpg', name: 'N. Shivani', role: 'HR Manager' },
      { img: '/img/img7.png', name: 'B. Srinivasulu', role: 'Lead Non-IT & Business Operations' },
      { img: '/img/img10.png', name: 'K. Pradeep', role: 'General Manager' },
      { img: '/img/img5.png', name: 'L. Kishore Babu ', role: 'Sr. Technical Lead' },
      
      
    ],
    'Marketing & Content': [
      { img: '/img/mahendra.jpg', name: 'S. Mahendra', role: 'Sr. Digital Marketing Executive' },
     
      { img: '/img/img1.jpg', name: 'A. Sai Kiran', role: 'Digital Marketing Executive' },
      { img: '/img/mounika.jpg', name: 'D. Mounika', role: 'Digital Marketing Executive' },
      
      
      { img: '/img/img11.png', name: 'A. Yaswanth', role: 'Content Creator' },
      { img: '/img/img12.png', name: 'J. Shashank', role: 'Content Creator' },
      { img: '/img/ksatish.png', name: 'K. Satish', role: 'Video Editor' },
    ],
    'Strategy & Business': [
      { img: '/img/vasanthi.jpg', name: 'P. Pushpa Vasanthi ', role: 'Sr. Domestic IT Recruiter' },
      // { img: '/img/chawan.jpg', name: 'C. Digambar', role: 'Field Sales Executive' },
      // { img: '/img/img3.jpg', name: 'K. Jahnavi', role: 'Sales & Marketing' },
    ],
  };

  const tabs = ['Technology & Development', 'Operations & Managment', 'Strategy & Business', 'Marketing & Content'];

  // Card Component
  const TeamMemberCard = ({ member, index }) => (
    <div
      key={index}
      className="bg-white rounded-2xl shadow-md border border-gray-100 flex flex-col items-center text-center p-4 sm:p-5 gap-2 sm:gap-3 group wow zoomIn"
      data-wow-duration="0.8s"
      data-wow-delay={`${0.1 * index}s`}
    >
      <div className="-mt-4 mb-1">
        <div className="w-28 h-28 sm:w-32 sm:h-32 md:w-36 md:h-36 rounded-full overflow-hidden border-4 border-indigo-200 shadow-lg bg-white">
          <img
            src={member.img}
            alt={member.name}
            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
          />
        </div>
      </div>

      <div>
        <h3 className="font-extrabold text-indigo-950 text-base sm:text-lg md:text-xl leading-tight mb-1">
          {member.name}
        </h3>
        <p className="text-blue-600 text-[11px] sm:text-xs md:text-sm font-medium">
          {member.role}
        </p>
      </div>

      <div className="w-10 sm:w-12 h-[1px] bg-gradient-to-r from-indigo-500 to-blue-400 rounded-full my-1" />
    </div>
  );

  return (
    <div className="min-h-screen bg-white font-sans">
      <Navbar />

      {/* HERO */}
      <header className="relative w-full">
        <div
          className="relative w-full h-[317px] bg-center bg-cover bg-no-repeat"
          style={{ backgroundImage: `url(${whobanner})` }}
        >
          {/* Dark overlay */}
          <div className="absolute inset-0 bg-black/55 lg:bg-black/60" />

          {/* Centered text content */}
          <div className="absolute inset-0 flex flex-col items-center justify-center text-white text-center px-4 z-10">
            <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold mb-4 drop-shadow-md">
              Our CoreXperts
            </h1>

            <div className="flex items-center gap-2 text-sm sm:text-base">
              <Link to="/" className="hover:underline">Home</Link>
              <svg
                width="7"
                height="10"
                viewBox="0 0 7 10"
                fill="none"
                className="mt-[2px]"
              >
                <path
                  d="M0.297 0.262C0.105 0.426 -0.002 0.648 0 0.878C0.002 1.109 0.113 1.329 0.308 1.492L4.02 4.604L0.366 7.711C0.173 7.875 0.067 8.097 0.069 8.328C0.071 8.558 0.182 8.778 0.377 8.941C0.474 9.022 0.59 9.086 0.717 9.13C0.844 9.174 0.981 9.196 1.118 9.195C1.255 9.194 1.391 9.171 1.518 9.126C1.644 9.081 1.758 9.016 1.854 8.933L6.232 5.212C6.329 5.131 6.405 5.034 6.457 4.927C6.509 4.821 6.535 4.706 6.534 4.591C6.533 4.476 6.505 4.362 6.451 4.256C6.397 4.15 6.319 4.054 6.221 3.974L1.774 0.254C1.677 0.173 1.561 0.109 1.434 0.065C1.307 0.021 1.171 -0.001 1.033 0C0.896 0.001 0.76 0.024 0.634 0.069C0.507 0.114 0.393 0.18 0.297 0.262Z"
                  fill="white"
                />
              </svg>
              <span>Our CoreXperts</span>
            </div>
          </div>
        </div>
      </header>

      {/* Leader Profiles */}
     {/* 🟦 Updated Leadership Section – G. Sri Manasa */}
<div className="bg-white rounded-lg shadow-lg p-4 sm:p-6 md:p-12 mb-8 sm:mb-12 flex flex-col lg:flex-row gap-4 sm:gap-6 md:gap-8 wow fadeInUp" data-wow-duration="1s">
  <img
    src="/img/madam.jpg"
    alt="G. Sri Manasa"
    className="w-full lg:w-64 h-100 sm:h-56 md:h-64 object-cover rounded-lg mt-5"
  />

  <div className="flex-1">
      <p>Leadership  </p>
    <h2 className="text-xl sm:text-2xl md:text-3xl lg:text-4xl font-bold text-indigo-950 mb-2">
      G. Sri Manasa
    </h2>

    <p className="text-blue-600 text-xs sm:text-sm md:text-base mb-3 sm:mb-4">
      Founder, Managing Director & Chief Technology Officer  
      <br />
      <span className="text-zinc-700">SecurXpert Technologies Pvt Ltd</span>
    </p>

    <h3 className="text-base sm:text-lg md:text-xl font-semibold text-indigo-900 mb-2">
      About G. Sri Manasa
    </h3>

    <p className="text-zinc-600 text-xs sm:text-sm leading-6 mb-3">
      G. Sri Manasa is the Founder, Managing Director and Chief Technology Officer of 
      SecurXpert Technologies Pvt Ltd. With over 10 years of industry experience, she leads 
      the company’s technology vision and engineering direction from the ground up.
    </p>

    <p className="text-zinc-600 text-xs sm:text-sm leading-6 mb-3">
      She played a key role in shaping SecurXperts into a product-driven technology company 
      with a strong focus on security and scalability. In the first year alone, she led 
      the development of more than 10 product MVPs — creating a strong technical foundation 
      for platforms and client solutions.
    </p>

    <p className="text-zinc-600 text-xs sm:text-sm leading-6 mb-3">
      As CTO, she oversees product architecture, software development, infrastructure, 
      cybersecurity and quality standards. She ensures every solution meets strict benchmarks 
      for performance, reliability and security.
    </p>

    <p className="text-zinc-600 text-xs sm:text-sm leading-6 mb-3">
      Her long-term vision is to establish SecurXpert as a globally trusted name in 
      security-led technology solutions. Her mission is to turn real business challenges 
      into robust, secure and production-ready systems that deliver lasting value.
    </p>

    <p className="text-zinc-600 text-xs sm:text-sm leading-6">
      As Managing Director, she also focuses on building internal systems, nurturing 
      technical talent and promoting a culture of accountability, learning and engineering 
      excellence.
    </p>
    {/* LinkedIn Button */}
<a
  href="https://www.linkedin.com/in/manasa-sree-94a64114b?utm_source=share_via&utm_content=profile&utm_medium=member_android" 
  target="_blank"
  rel="noopener noreferrer"
  className="inline-flex items-center gap-2 mt-4 sm:mt-6 text-blue-700 hover:text-blue-900 font-semibold text-sm sm:text-base transition-all"
>
  <svg 
    xmlns="http://www.w3.org/2000/svg" 
    width="22" height="22" 
    viewBox="0 0 24 24" 
    fill="currentColor"
  >
    <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 
             2.239 5 5 5h14c2.762 0 5-2.239 
             5-5v-14c0-2.761-2.238-5-5-5zm-11 
             20h-3v-11h3v11zm-1.5-12.268c-.966 
             0-1.75-.79-1.75-1.764s.784-1.764 
             1.75-1.764 1.75.79 1.75 
             1.764-.783 1.764-1.75 
             1.764zm13.5 12.268h-3v-5.604c0-1.337 
             0-3.396-2.063-3.396-2.065 
             0-2.379 1.479-2.379 
             3.301v5.699h-3v-11h2.879v1.529h.041c.401-.761 
             1.379-1.563 2.839-1.563 3.036 
             0 3.683 2.036 3.683 4.685v6.349z"/>
  </svg>

  <span>Connect on LinkedIn</span>
</a>

  </div>
</div>

{/* 🟦 Updated Leadership Section – G. Praveen Kumar */}
<div
  className="bg-white rounded-lg shadow-lg p-4 sm:p-6 md:p-12 flex flex-col lg:flex-row gap-4 sm:gap-6 md:gap-8 wow fadeInUp"
  data-wow-duration="1s"
  data-wow-delay="0.3s"
>
  <div className="flex-1 lg:order-1">
    <p>Leadership  </p>
    <h2 className="text-xl sm:text-2xl md:text-3xl lg:text-4xl font-bold text-indigo-950 mb-2">
      G. Praveen Kumar
    </h2>

    <p className="text-blue-600 text-xs sm:text-sm md:text-base mb-3 sm:mb-4">
      Co-Founder & Chief Executive Officer  
      <br />
      <span className="text-zinc-700">SecurXpert Technologies Pvt Ltd</span>
    </p>

    <h3 className="text-base sm:text-lg md:text-xl font-semibold text-indigo-900 mb-2">
      About G. Praveen Kumar
    </h3>

    <p className="text-zinc-600 text-xs sm:text-sm leading-6 mb-3">
      G. Praveen Kumar is the Co-Founder and Chief Executive Officer of SecurXpert 
      Technologies Pvt Ltd and leads the company’s global business strategy, growth and 
      operations. He brings over a decade of experience in business development, 
      operations and client management.
    </p>

    <p className="text-zinc-600 text-xs sm:text-sm leading-6 mb-3">
      Since co-founding the company, he has been instrumental in scaling SecurXpert from an 
      early-stage startup into a fast-growing international organization. Under his 
      leadership, the company expanded globally and initiated its UK operations within the 
      first year.
    </p>

    <p className="text-zinc-600 text-xs sm:text-sm leading-6 mb-3">
      As CEO, he drives corporate strategy, partnerships and market expansion. He oversees 
      major functions including operations, recruitment, compliance, delivery governance 
      and process frameworks that support international growth.
    </p>

    <p className="text-zinc-600 text-xs sm:text-sm leading-6 mb-3">
      His vision is to transform SecurXpert into a globally credible security and 
      technology partner for enterprises. His mission is to create a scalable, 
      execution-focused organization driven by discipline, client trust and sustainable 
      growth.
    </p>

    <p className="text-zinc-600 text-xs sm:text-sm leading-6">
      He is also deeply involved in strengthening leadership systems and fostering a 
      performance-driven culture to ensure the company grows responsibly and consistently.
    </p>
    {/* LinkedIn Button */}
<a
  href="https://www.linkedin.com/in/praveen-kumar-gannavarapu-3341b6239?utm_source=share_via&utm_content=profile&utm_medium=member_android" 
  target="_blank"
  rel="noopener noreferrer"
  className="inline-flex items-center gap-2 mt-4 sm:mt-6 text-blue-700 hover:text-blue-900 font-semibold text-sm sm:text-base transition-all"
>
  <svg 
    xmlns="http://www.w3.org/2000/svg" 
    width="22" height="22" 
    viewBox="0 0 24 24" 
    fill="currentColor"
  >
    <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 
             2.239 5 5 5h14c2.762 0 5-2.239 
             5-5v-14c0-2.761-2.238-5-5-5zm-11 
             20h-3v-11h3v11zm-1.5-12.268c-.966 
             0-1.75-.79-1.75-1.764s.784-1.764 
             1.75-1.764 1.75.79 1.75 
             1.764-.783 1.764-1.75 
             1.764zm13.5 12.268h-3v-5.604c0-1.337 
             0-3.396-2.063-3.396-2.065 
             0-2.379 1.479-2.379 
             3.301v5.699h-3v-11h2.879v1.529h.041c.401-.761 
             1.379-1.563 2.839-1.563 3.036 
             0 3.683 2.036 3.683 4.685v6.349z"/>
  </svg>

  <span>Connect on LinkedIn</span>
</a>

  </div>

  <img
    src="/img/sir.jpg"
    alt="G. Praveen Kumar"
    className="w-full lg:w-64 h-100 sm:h-56 md:h-64 object-cover rounded-lg lg:order-2 mt-3"
  />
</div>


      {/* Team Section */}
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-8 sm:py-12 md:py-16">
        <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-indigo-950 text-center mb-3 sm:mb-4 leading-tight wow fadeInUp" data-wow-duration="1s">
           People Behind the Innovation
        </h2>
        <p className="text-lg sm:text-xl md:text-2xl text-zinc-600 text-center mb-4 sm:mb-6 md:mb-8 wow fadeInUp" data-wow-duration="1s" data-wow-delay="0.2s">
          Passionate. Certified. Future-Ready.
        </p>
        <p className="text-sm sm:text-base text-zinc-600 text-center mb-6 sm:mb-8 md:mb-12 max-w-5xl mx-auto leading-6 wow fadeInUp" data-wow-duration="1s" data-wow-delay="0.4s">
          Our CoreXperts are innovators, problem-solvers, and collaborators who turn bold ideas into powerful realities. 
        </p>

        {/* Tabs */}
       <div
  className="grid grid-cols-2 sm:grid-cols-4 gap-2 sm:gap-4 mb-6 sm:mb-8 md:mb-12 px-2 sm:px-4 wow fadeInUp"
  data-wow-duration="1s"
  data-wow-delay="0.6s"
>
  {tabs.map((tab) => (
    <button
      key={tab}
      onClick={() => setActiveTab(tab)}
      className={`
        text-xs sm:text-sm md:text-base lg:text-xl xl:text-2xl
        font-normal transition-all
        px-3 sm:px-4 md:px-6 lg:px-8 py-1 sm:py-2 rounded-lg text-center
        ${
          activeTab === tab
            ? "text-white bg-indigo-950"
            : "text-zinc-600 hover:text-indigo-950 hover:bg-indigo-100"
        }
      `}
    >
      {tab}
    </button>
  ))}
</div>


        {/* Team Grid */}
        <div
          className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 sm:gap-6 mb-2 sm:mb-16"
          key={activeTab}
        >
          {(teamData[activeTab] || []).map((member, index) => (
            <TeamMemberCard key={index} member={member} index={index} />
          ))}
        </div>
      </div>

      {/* What Sets Us Apart */}
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-2   mb-20">
        <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-indigo-950 text-center mb-8 sm:mb-12 md:mb-16 leading-tight wow fadeInUp" data-wow-duration="1s">
          Why Our CoreXperts Stand Out
        </h2>

        <div className="grid md:grid-cols-2 gap-6 sm:gap-8 md:gap-12 lg:gap-16 items-center">
          {/* Image */}
          <div className="relative">
            <div className="relative z-10 flex justify-center wow fadeInLeft" data-wow-duration="1s">
              <img
                src="/img/standout.jpg"
                alt="Our team"
                className="w-80 sm:w-[380px] md:w-[460px] lg:w-[520px] h-auto object-cover rounded-lg shadow-lg"
              />
            </div>
          </div>

          {/* Features */}
          <div className="space-y-4 sm:space-y-6 md:space-y-8 relative">
            {[
              { title: 'End-to-End Expertise', description: 'From ideation to deployment — we own the full lifecycle.' },
              { title: '50+ Global Certifications', description: 'AWS, Azure, Google Cloud, React, DevOps, Cybersecurity & more.' },
              { title: 'Innovation-First Culture', description: 'Always exploring AI, blockchain, and emerging tech.' },
              { title: 'Hyderabad-Proud, Globally Trusted', description: 'Delivering excellence from India to the world.' },
              { title: 'Digital Marketing & Sales Expertise', description: ' We help brands grow faster through strategic marketing, performance campaigns, and data-driven sales enablement.' },
            ].map((feature, index) => (
              <div
                key={index}
                className="flex gap-3 sm:gap-4 md:gap-6 items-start wow fadeInRight"
                data-wow-duration="1s"
                data-wow-delay={`${0.2 * index}s`}
              >
                <div className="flex-shrink-0">
                  <div className="w-9 h-9 sm:w-10 sm:h-10 md:w-11 md:h-11 bg-indigo-950 text-white rounded-full flex items-center justify-center font-normal text-lg sm:text-xl md:text-2xl">
                    {index + 1}
                  </div>
                </div>
                <div className="pt-1">
                  <p className="text-zinc-600 text-base sm:text-lg md:text-xl lg:text-2xl leading-6 sm:leading-7 md:leading-9">
                    <span className="font-bold">{feature.title} </span>
                    <span className="font-normal">{feature.description}</span>
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>

      </div>

      {/* CTA Section */}
      <div className="relative bg-indigo-950 py-12 sm:py-16 md:py-24 overflow-hidden">
        <svg className="absolute left-0 top-0 w-32 sm:w-40 md:w-52" viewBox="0 0 202 128" fill="none">
          <path d="M201.567 0.892918L-5.36442e-06 127.999L0.568619 0L201.567 0.892918Z" fill="#3E66F3" />
        </svg>
        <svg className="absolute right-0 bottom-0 w-32 sm:w-40 md:w-52" viewBox="0 0 202 128" fill="none">
          <path d="M-2.53916e-05 127.106L201.567 4.57764e-05L200.998 127.999L-2.53916e-05 127.106Z" fill="#3E66F3" />
        </svg>
        <div className="relative z-10 max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center wow fadeInUp" data-wow-duration="1s" data-wow-delay="0.2s">
          <h2 className="text-xl sm:text-2xl md:text-3xl lg:text-4xl font-bold text-white mb-4 sm:mb-6 md:mb-8 leading-tight">
            Ready to Build Something Extraordinary?
          </h2>
          <p className="text-base sm:text-lg md:text-xl lg:text-2xl text-white mb-4 sm:mb-6 md:mb-8 leading-7 sm:leading-8 md:leading-9">
            Let our CoreXperts turn your vision into a secure, scalable, and future-proof reality.
          </p>
          <p className="text-base sm:text-lg md:text-xl lg:text-2xl text-white font-bold leading-7 sm:leading-8 md:leading-9">
            Innovate Today. Lead Tomorrow.
          </p>
        </div>
      </div>
 <Footer />
 
      {/* <Footer /> */}


      {/* Scroll to Top Button with circular progress */}
      {showScroll && (
        <div
          onClick={scrollToTop}
          className="scroll-top fixed bottom-6 right-6 z-50 cursor-pointer flex items-center justify-center w-14 h-14 rounded-full bg-gradient-to-r from-blue-500 to-blue-700 shadow-lg hover:from-blue-600 hover:to-blue-800 transition-all"
        >
          <svg
            className="progress-circle -rotate-90 w-12 h-12 absolute"
            viewBox="-1 -1 102 102"
          >
            <path
              d="M50,1 a49,49 0 0,1 0,98 a49,49 0 0,1 0,-98"
              fill="none"
              stroke="white"
              strokeWidth="4"
              strokeDasharray="307.919"
              strokeDashoffset={307.919 - scrollProgress * 307.919}
              style={{ transition: 'stroke-dashoffset 0.1s linear' }}
            />
          </svg>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="w-6 h-6 text-white relative z-10"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            strokeWidth={2}
          >
            <path strokeLinecap="round" strokeLinejoin="round" d="M5 15l7-7 7 7" />
          </svg>
        </div>
      )}
    </div>
    
  );
};

export default OurCoreXperts;
